var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDefense(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 24,
    viewBox: "0 0 22 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.9294 3.77598L20.5993 11.818C20.4558 15.2995 18.6792 18.5098 15.8049 20.4791L12.9198 22.4562C11.7416 23.2639 10.1881 23.2639 9.00987 22.4562L6.12481 20.4791C3.25055 18.5098 1.47294 15.2995 1.33045 11.818L1.00028 3.77598C0.991438 3.54899 1.1919 3.37015 1.41594 3.40749C2.04975 3.51263 2.70125 3.56668 3.36454 3.56668C6.06781 3.56668 8.55981 2.66264 10.5536 1.13953C10.7963 0.954792 11.1324 0.954792 11.3751 1.13953C13.3699 2.66264 15.8619 3.56668 18.5642 3.56668C19.2285 3.56668 19.879 3.51165 20.5128 3.40749C20.7378 3.37015 20.9393 3.54899 20.9294 3.77598Z",
    stroke: "#7AD037",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9641 1.00098V23.0615",
    stroke: "#7AD037",
    strokeWidth: 1.2,
    strokeMiterlimit: 10
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefense);
export default __webpack_public_path__ + "static/media/defense.a7058ce9f8a83d069df514f59c2db6f0.svg";
export { ForwardRef as ReactComponent };